import { get } from 'lodash'

export default function(path) {
    return path ? get(window.srClientData, path) : window.srClientData
}
